import * as React from 'react';
type Props = {
  className?: string;
};
export function LowCarb({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-LowCarb"
      className={className}
    >
      <path
        d="M12.8738 14.5164L12.8604 36M12.8738 14.5164C6.46184 8.68667 12.8992 3 12.8992 3C19.0093 9.1416 12.8738 14.5164 12.8738 14.5164ZM29.3818 4.94899V21.1986M24.5071 16.5197L29.3556 21.8621L34.257 16.4615M20.6979 22.4298C20.6979 22.4298 21.548 30.9775 12.8827 30.8895C12.8827 30.8895 12.0414 22.7756 20.6979 22.4298ZM5.02288 22.4298C5.02288 22.4298 4.17269 30.9775 12.8381 30.8895C12.8381 30.8895 13.6794 22.7756 5.02288 22.4298ZM20.6979 13.2916C20.6979 13.2916 21.548 21.8393 12.8827 21.7513C12.8827 21.7513 12.0414 13.6374 20.6979 13.2916ZM5.02288 13.2916C5.02288 13.2916 4.17269 21.8393 12.8381 21.7513C12.8381 21.7513 13.6794 13.6374 5.02288 13.2916Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
